import { ClipboardList } from "lucide-react";
import { useEffect, useState } from "react";
import { toast } from "sonner";

import { api } from "@/api";

const FLAGS = { nombre: ["type", "number"], email: ["type", "email"], somme: ["sum", true], total: ["total", true] };

// Format texte simple : « # Bloc », « > texte à dire », « - 2. Question * : choix A | choix B (nombre) → Champ »
export const toText = (blocks) => blocks.map((b) => [
  `# ${b.title}`,
  ...(b.say ? b.say.split("\n").map((l) => `> ${l}`) : []),
  ...b.questions.map((q) => `- ${q.n ? `${q.n}. ` : ""}${q.label}${q.required ? " *" : ""}${q.options ? ` : ${q.options.join(" | ")}` : ""}${Object.entries(FLAGS).filter(([, [k, v]]) => q[k] === v).map(([w]) => ` (${w})`).join("")}${q.field ? ` → ${q.field}` : ""}`),
].join("\n")).join("\n\n");

export const fromText = (text) => {
  const blocks = [];
  for (const raw of text.split("\n")) {
    const line = raw.trimEnd();
    if (line.startsWith("# ")) blocks.push({ title: line.slice(2).trim(), say: "", questions: [] });
    else if (!blocks.length) continue;
    else if (line.startsWith(">")) { const b = blocks[blocks.length - 1]; b.say = b.say ? `${b.say}\n${line.replace(/^>\s?/, "")}` : line.replace(/^>\s?/, ""); }
    else if (line.startsWith("- ")) {
      let s = line.slice(2).trim();
      const q = {};
      const field = s.match(/\s*→\s*(.+)$/);
      if (field) { q.field = field[1].trim(); s = s.slice(0, field.index); }
      Object.entries(FLAGS).forEach(([w, [k, v]]) => { if (s.includes(`(${w})`)) { q[k] = v; s = s.replace(`(${w})`, ""); } });
      const n = s.match(/^(\d+)\.\s*/);
      if (n) { q.n = Number(n[1]); s = s.slice(n[0].length); }
      const [label, opts] = s.split(/\s+:\s+/);
      q.label = label.replace(/\s*\*\s*$/, "").trim();
      if (/\*\s*$/.test(label)) q.required = true;
      if (opts) q.options = opts.split("|").map((o) => o.trim()).filter(Boolean);
      if (q.label) blocks[blocks.length - 1].questions.push(q);
    }
  }
  return blocks;
};

export function GuidedScriptsSection() {
  const [data, setData] = useState(null);
  const [key, setKey] = useState("particulier");
  const [text, setText] = useState("");
  useEffect(() => { api.get("/settings/guided-scripts").then(({ data: d }) => setData(d)).catch(() => setData(false)); }, []);
  useEffect(() => { if (data) setText(toText(data.profiles[key]?.script || [])); }, [data, key]);
  if (!data) return null;
  const save = async () => {
    const scripts = Object.fromEntries(Object.entries(data.profiles).map(([k, v]) => [k, k === key ? fromText(text) : v.script]));
    try { setData((await api.put("/settings/guided-scripts", { scripts })).data); toast.success("Script enregistré."); } catch (e) { toast.error(e?.response?.data?.detail || "Erreur, réessayez."); }
  };
  return (
    <section className="settings-section" id="scripts" data-testid="guided-scripts-section">
      <div className="section-title"><ClipboardList size={20} /><div><p className="eyebrow">SCRIPTS GUIDÉS</p><h2>Script de qualification par type de prospect</h2></div></div>
      <p className="fileprep-dedup-hint">Une ligne « # » ouvre un bloc, « &gt; » est le texte à dire par l'agent, « - » une question : « * » obligatoire, « : A | B » les choix, « (nombre) », « → Champ » pour remplir un champ de la fiche.</p>
      <div className="lr-chips">{Object.entries(data.profiles).map(([k, v]) => <button key={k} type="button" className={key === k ? "is-on" : ""} onClick={() => setKey(k)} data-testid={`guided-script-tab-${k}`}>{v.label}</button>)}</div>
      <textarea className="gs-editor" rows={18} value={text} onChange={(e) => setText(e.target.value)} spellCheck={false} data-testid="guided-script-editor" />
      <button type="button" className="primary-button" onClick={save} data-testid="guided-script-save">Enregistrer le script</button>
    </section>
  );
}
